import request from '@/util/request';
import qs from 'qs';

export const getMonthcarList = (params, options) =>
  request.get('/api/v4ward/monthcar/v1/list', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/car/ChargeRule/remove', qs.stringify(params), options);

export const monthcarStatusCount = (params, options) =>
  request.get('/api/v4ward/monthcar/v1/status/count', Object.assign({}, options, { params }));

export const getCarParkList = (params, options) =>
  request.get('/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0', Object.assign({}, options, { params }));

  export const getParkSpaceList = (params, options) =>
  request.get('/api/v4ward/monthcar/v1/parkspace/list', Object.assign({}, options, { params }));

  export const getMonthcarDetail = (params, options) =>
  request.get('/api/v4ward/monthcar/v1/detail', Object.assign({}, options, { params }));

  export const getMonthcarNewDetail = (params, options) =>
  request.get('/api/v4ward/monthcar/v1/new/detail', Object.assign({}, options, { params }));

//小区下拉框
  export const loadPayStatusPlatformV1 = (params = {}, options = {}) =>
    request.get(
      "/api/v4ward/monthcar/v1/pay/query",
      Object.assign({}, options, { params })
    );
  //月卡车二维码支付
  export const billPayNewSubmit = (params, options) =>
  request.post('/api/v4ward/monthcar/v1/pay', params, options);
  //月卡车二维码支付
  export const saveCarQrCodePay = (params, options) =>
  request.post('/api/v4ward/monthcar/v1/pay/qrCodePay', params, options);
  //月卡车条形码支付
  export const saveCarBarCodePay = (params, options) =>
  request.post('/api/v4ward/monthcar/v1/pay/barCodePay', params, options);
  //月卡车查询支付状态
  export const loadCarPayStatus = (params, options) =>
  request.get('/api/v4ward/monthcar/v1/pay/status/query', Object.assign({}, options, { params }));
  //删除月卡车
export const deleteCarMonth = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/deleteCarMonthV1', qs.stringify(params), options);
  //修改月卡车
  export const modifyCarMonth = (params, options) =>
  request.post('/api/v4ward/monthcar/v1/modifyCarMonth', params, options);
  //月卡车审核通过
  export const auditCarMonth = (params, options) =>
  request.post('/api/v4ward/monthcar/v1/auditCarMonth', params, options);
  //月卡车审核修改详情
  export const getMonthcarAuditDetail = (params, options) =>
  request.get('/api/v4ward/monthcar/v1/audit/detail', Object.assign({}, options, { params }));


